<template>
  <el-dialog title="确认交付" :visible.sync="visible" :close-on-click-modal="false" :close-on-press-escape="false" width="30%">
    <el-form :model="data" :rules="rules" ref="addForm" label-width="90px">
      <el-form-item label="交付日期:" prop="deliveryDate">
            <el-date-picker v-model="data.deliveryDate" value-format="yyyy-MM-dd" type="date" placeholder="选择日期" style="width:100%"></el-date-picker>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="confirm">确认</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { confirmDelivery } from "@/api/crm/order";
import { mapState } from 'vuex'

export default {
  name: "expressDialog",
  props: {
  },
  data() {
    return {
      visible: false,
      rules: {
        deliveryDate: [
          {required: true, message: '请选择交付日期', trigger: 'change'}
        ]
      },
      data: {
        id: null,
        deliveryDate: null,
      }
    };
  },
  created() {
  },
  computed: {
    ...mapState({
      currentUserId: state => state.user.userId
    })
  },
  watch: {
    visible (val) {
      if (!val) {
        this.data.id = null;
        this.data.expressDate = null,
        this.data.logisticsCompanyCode = null,
        this.data.expressRemark = null
      }
    }
  },
  methods: {
    open (id) {
      this.data.id = id;
      this.visible = true
    },
    confirm () {
      this.$refs['addForm'].validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '加载中',
            spinner: 'el-icon-loading'
          });
          confirmDelivery(this.data).then(response => {
            this.$emit('success')
            this.visible = false
            loading.close();
            this.msgSuccess("确认成功");
          }).catch(error => {
            loading.close()
          })
        } else {
          this.msgWarning("请检查必填项");
          return false;
        }
      });
    }
  }
};
</script>
